import { message } from "antd";
import moment from "moment";
import { debounce } from "lodash";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import store, { persistor } from "../../../store";
import {
  setPendingAction,
  getPendingAction,
  setExecutePendingAction,
} from "../../../store/actions/procedureDetailPageActions";

import { globalPendingRequests } from "utils/rest/utils";

const getLatestProcedureInfo = (procedureTaskId: any) => {
  return new Promise((resolve) => {
    ProcedureDetailService.getProcedureInfoByProcedureTaskId(
      { procedureTaskId },
      (result: any) => resolve(result),
      () => {
        message.error("Failed To Get Procedure Data!", 3);
        resolve(null);
      }
    );
  });
};

const CALL_BACK_TYPE = {
  ONLY_MESSAGE: "ONLY_MESSAGE",
  ONLY_RELOAD: "ONLY_RELOAD",
};
/**
 * @typedef {Object} CheckLatestProcedureInfoParams
 * @property {typeof PendingActionTypes[keyof typeof PendingActionTypes]} actionType - The type of pending action
 * @property {string} procedureTaskId - The ID of the procedure task
 * @property {typeof CALL_BACK_TYPE[keyof typeof CALL_BACK_TYPE]} [callbackType=CALL_BACK_TYPE.ONLY_RELOAD] - The type of callback
 * @property {() => void} [showLoading] - Function to show loading state
 * @property {() => void} [hideLoading] - Function to hide loading state
 */
const checkLatestProcedureInfo = async ({
  actionType,
  procedureTaskId,
  callbackType = CALL_BACK_TYPE.ONLY_RELOAD,
}: any) => {
  const pendingAction = getPendingAction();
  if (pendingAction === actionType) {
    //recover from refresh
    store.dispatch(setPendingAction(null));
    await persistor.flush();
    await monitorPersistentRequests();
    scrollToTargetSection(pendingAction);
    store.dispatch(setExecutePendingAction(false));
  } else {
    const {
      // @ts-ignore
      procedureDetailPage: { modifiedTime: lastModifiedTime },
    } = store.getState();
    const response = await getLatestProcedureInfo(procedureTaskId);
    // @ts-ignore
    const latestModifiedTime = response?.modifiedTime;
    // @ts-ignore
    if (!response?.procedureID) {
      // @ts-ignore
      window.location = "/NoPermissionPage/noAccess";
      await new Promise(() => {});
      return false;
    }
    if (response && moment(latestModifiedTime).isAfter(moment(lastModifiedTime))) {
      const map = {
        [CALL_BACK_TYPE.ONLY_RELOAD]: async () => {
          store.dispatch(setPendingAction(actionType));
          await persistor.flush();
          await new Promise(() => {});
          return true;
        },
        [CALL_BACK_TYPE.ONLY_MESSAGE]: () => {
          message.destroy();
          message.warning(
            "This section has been updated by another user. Please refresh the page and resubmit the change.",
            5
          );
          return false;
        },
      };
      return map[callbackType]();
    }
  }
  return true;
};

const scrollToTargetSection = (pendingAction: any) => {
  if (!pendingAction) return;
  let targetId = "";
  if (pendingAction.startsWith("SharedTasks")) {
    targetId = "Shared Tasks";
  } else if (pendingAction.startsWith("ProcedureInfo")) {
    targetId = "Procedure Information";
  } else if (pendingAction.startsWith("SupportingFiles")) {
    targetId = "Supporting Files";
  }
  //  else if (pendingAction.startsWith('ProcedureFiles')) {
  //   targetId = 'Procedure Files'
  // }
  return new Promise((resolve) => {
    const targetElement = document.querySelector(`[data-scroll-target-id="${targetId}"]`);
    if (targetElement) {
      const handleScrollEnd = debounce(() => {
        window.removeEventListener("scroll", handleScrollEnd);
        // @ts-ignore
        resolve();
      }, 150);

      window.addEventListener("scroll", handleScrollEnd);
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // @ts-ignore
      resolve();
    }
  });
};

const monitorPersistentRequests = async () => {
  while (globalPendingRequests.size > 0) {
    await new Promise((r) => setTimeout(r, 16));
  }
};

export { getLatestProcedureInfo, checkLatestProcedureInfo, monitorPersistentRequests };
